import { Device } from '@twilio/voice-sdk';
import { useEffect, useState } from 'react';
import { createLogger } from './logger/logger';

/**
 *This is used for external call and on call  
 */
const fileLabel = 'useTwilioDevice.tsx';
const logger = createLogger({
  fileLabel,
});

const useTwilioDevice = (token) => {
  const [agentDevice, setAgentDevice] = useState(new Device(token));
  const [deviceConnected, setDeviceConnected] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  useEffect(() => {
    agentDevice.register();

    agentDevice.on('registered', (device) => {
      setAgentDevice(agentDevice);
      setDeviceConnected(true);
      logger.info('device is ready to use', device);
    });

    agentDevice.on('error', (err) => {
      setDeviceConnected(false);
      setError(error);
      logger.error('Error in Registering device', err);
    });

    return () => agentDevice.destroy();
  }, []);

  return {
    deviceConnected,
    agentDevice,
    error,
  };
};

export default useTwilioDevice;
